import { render } from "./CountdownBadge.vue?vue&type=template&id=bb3e8174"
import script from "./CountdownBadge.vue?vue&type=script&lang=js"
export * from "./CountdownBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__